/* 全局有三个参数 
 * # ___PROJECT 项目名称
 * # ___ENV 环境模式 development || production
 * # ___VERSION 版本号（不带v）
*/

//辅助组件之间的事件广播
export const eventBus = {
  beforeCreate () {
    let parent = this.$parent
    while (parent && !this.$bus) {
      if (parent.$bus) {
        this.$bus = parent.$bus
      } else {
        parent = parent.$parent
      }
    }
  }
}

//# 创建随机字符串
export const createKey = function(){
	let len = 8;
	let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz";
	let maxPos = chars.length;
	let key = '';
	for (let i = 0; i < len; i++) {
	  key += chars.charAt(Math.floor(Math.random() * maxPos));
	}

	return key;
}

//# 获取链接参数
const url={};
const urlSearch = window.location.search;
if(urlSearch){
	var urlSearch_temp = urlSearch.split("?");
	if(urlSearch_temp.length>1){
		var urlSearch_temp2 = urlSearch_temp[1].split("&");
		urlSearch_temp2.forEach(d=>{
			if(d.indexOf("=")>0){
				var urlSearch_temp3 = d.split("=");
				if(urlSearch_temp3.length>1 && urlSearch_temp3[0]!==""){
					url[urlSearch_temp3.shift()]=urlSearch_temp3.join("=");
				}
			}
		})
	}
}
export {url}

//# 类拷贝 复制避免地址指向污染
//# 注意：无法拷贝无限级嵌套的对象
export const extend = (objArr)=>{
  if(typeof objArr === 'object'){
    return JSON.parse(JSON.stringify(objArr));
  }return objArr;
}

//# 转换预约时间 "09:00~21:00" 转换为 [09:05,09:10,...20:50,20:55]
export const appointTimes = {

  timerEX:15
  ,block1:function(h1,m1,h2,m2){
    var _m1=m1,_h1=h1;
    if(m1<(60-this.timerEX)){
        _m1 += this.timerEX;
    }else{
        _m1 += this.timerEX-60;
        _h1++;
    }
    if(h1<10){h1="0"+h1}
    if(m1<10){m1="0"+m1}
    if((_h1*60+_m1) <= (h2*60+m2)){
        return [h1+":"+m1].concat(this.block1(_h1,_m1,h2,m2));
    }else{
        return h1+':'+m1;
    }
  }
  ,change:function(times){
    var _times = [];
    times.map(dTime=>{
      var temp1 = dTime.split("~");
      var temp2_0 = temp1[0].split(":");temp2_0[0] = parseInt(temp2_0[0]);temp2_0[1] = parseInt(temp2_0[1]);
      var temp2_1 = temp1[1].split(":");temp2_1[0] = parseInt(temp2_1[0]);temp2_1[1] = parseInt(temp2_1[1]);

      _times = _times.concat(this.block1(temp2_0[0],temp2_0[1],temp2_1[0],temp2_1[1]));
    });

    return _times;
  }

}

//由于 localStorage 与 sessionStorage 的方法基本上一致
//遂定义 _storage 为单位,复制对应的 localStorage 与 sessionStorage 方法
//@ 本地存储基础方法
//@ 将在后边黑魔法于 localStorage 和 sessionStorage
//@ Utils.data.L.set("user",{ name:"Frontend" }); //or Utils.data.set(..)
//@ Utils.data.L.get("user"); //or Utils.data.get('user')
//@ .set  [缓存key,缓存值] 保存缓存
//@ .get  [缓存key]   获取缓存
//@ .remove [缓存key]   移除缓存
//@ .push   [缓存key,push项] 在已存储的数组类型缓存中 push 值, 替代 get+push+set
//@ ._check [无参数]     检验是否支持本地缓存

//@ FUNCTION.DATA.LOCALSTORAGE => F.D.L
//@ FUNCTION.DATA.SESSIONSTORAGE => F.D.S
var _storage = {
  _target:"localStorage",
  get:function(key){
    if(!this._check()){return false;}
    if(!key){
      try{
        var obj = {};
        for(var k in window[this._target]){
          obj[k] = this.get(k);
        }
        return obj;
      }catch(e){
        return {};
      }
    }

    try{
      return JSON.parse(window[this._target].getItem(key));
    }catch(e){
      return window[this._target].getItem(key);
    }

  },
  set:function(key,val){
    if(!this._check()){return false;}
    if(!key){console.error("!key");return false;}
    if(typeof val == 'undefined'){val = "";}

    var data = "";
    if(typeof val !== "string"){
      data = JSON.stringify(val);
    }else{
      data = val;
    }

    window[this._target].setItem(key,data);

    return true;
  },
  remove:function(key){
    if(!key){console.error("!key");return false;}
    var temp = this.get(key);
    window[this._target].removeItem(key);
    return temp;
  },
  push:function(key,pushData){
    if(!key){console.error("!key");return false;}
    var targetData = this.get(key);
    if(targetData){
      if(typeof targetData == 'object' && typeof targetData.push == 'function'){
        targetData.push(pushData?pushData:"");
        this.set(key,targetData);
        return targetData.length;
      }else{
        console.error("key targetData is not a array");
        return false;
      }
    }else{
      this.set(key,[pushData?pushData:""]);
      return 1;
    }
  },
  _check:function(){
    if(!window[this._target]){console.error("!window."+this._target);return false;}
    return true;
  }
};
export const data = {
  S: {..._storage,_target:'sessionStorage'}
  ,L: {..._storage,_target:'localStorage'}
  ,...{..._storage,_target:'localStorage'}
}

//在数组（包含对象）里查找
//下标
//Utils.findObjectIndexInArray([{a:1},{a:2}],'a',3); return -1;
//Utils.findObjectIndexInArray([{a:1},{a:2}],'a',2); return 1;
const findObjectIndexInArray = (arr,key,value)=>{
  return arr.findIndex(obj=>typeof obj[key]!== 'undefined' && obj[key]===value);
}
//对象
//Utils.findObjectInArray([{a:1},{a:2}],'a',3); return false;
//Utils.findObjectInArray([{a:1},{a:2}],'a',2); return {a:2};
const findObjectInArray = (arr,key,value)=>{
  return arr.find(obj=>typeof obj[key]!== 'undefined' && obj[key]===value)||false;
}
//多对象
//Utils.findObjectsInArray([{a:1},{a:2},{a:2}],'a',3); return [];
//Utils.findObjectsInArray([{a:1},{a:2},{a:2}],'a',2); return [{a:2},{a:2}];
//Utils.findObjectsInArray([{a:1},{a:2},{a:2}],'a',1); return [{a:1}];
const findObjectsInArray = (arr,key,value)=>{
  return arr.filter(obj=>typeof obj[key]!== 'undefined' && obj[key]===value)||[];
}
export {findObjectIndexInArray,findObjectInArray,findObjectsInArray};

//判断是否为空 空数组，空字符串，undefined，Null，空对象
//！注意，0，"false"亦为空
//isNotEmpty(1) true;
//isNotEmpty(0) false;
//isNotEmpty(-1) true;
//isNotEmpty("") false;
//isNotEmpty("A") true;
//isNotEmpty("1") true;
//isNotEmpty("0") true;
//isNotEmpty("false") true;
//isNotEmpty([]) true;
//isNotEmpty([1]) true;
//isNotEmpty({}) false;
//isNotEmpty({A:1}) true;
//isNotEmpty(null) false;
//isNotEmpty(undefined) false;
//isNotEmpty(false) false;
//isNotEmpty(true) true;
export const isNotEmpty = function(target){
	if(typeof target === 'object'){
    if(Array.isArray(target) && target.length > 0){
      return !0;
    }else{
      for(var k in target){
        return !0;
      }
      return !1;
    }
  }else {
    return !!target
  }

}


//坐标转换
const coordtransform = require("coordtransform");
var mapTrans = {
    gd2gg:coordtransform.gcj02towgs84
    ,gg2gd:coordtransform.wgs84togcj02
    ,gd2bd:coordtransform.gcj02tobd09
    ,bd2gd:coordtransform.bd09togcj02
}

export {mapTrans};

//md5
var md5 = require('md5');
export {md5};

//获取字符串长度
export const getStrLength = (str)=>{
  let len = 0;
  str.split('').forEach(item => {
    let code = item.charCodeAt();
    if((code >= 0x0001&&code <= 0x007e) || (0xff60 <= code && code <= 0xff9f)){
      len ++;
    }else{
      len += 2;
    }
  })
  return len;
}


// WEBPACK FOOTER //
// core-build-local/plugs/utils.js